import React, { Component } from "react";
import Skeleton from "react-loading-skeleton";

class SkeletonImage extends Component {
  state = {
    image: ""
  };

  handleImageLoaded() {
    this.setState({ image: "loaded" });
  }

  render() {
    return (
      <div>
        {!this.state.image && (
          <Skeleton
            height={this.props.skeletonHeight}
            width={this.props.skeletonWidth}
          />
        )}
        <img src={this.props.src} onLoad={this.handleImageLoaded.bind(this)} />
      </div>
    );
  }
}

export { SkeletonImage };
